'use client';

import type { ReactNode } from 'react';
import { useWishlistSessionToken } from './hooks/use-wishlist-session-token';
import { WishlistProviderOptimized } from './wishlist-provider-optimized';

export function WishlistProviderQueryOptimized({
  children,
}: { children: ReactNode }) {
  const { data: authToken, isLoading, isError } = useWishlistSessionToken();

  // Don't render wishlist provider until we have token data
  if (isLoading) {
    return <>{children}</>;
  }

  // If error or no token, render children without wishlist
  if (isError || !authToken) {
    return <>{children}</>;
  }
  return (
    <WishlistProviderOptimized enabled={true}>
      {children}
    </WishlistProviderOptimized>
  );
}
